export function formatPhone(str) {
    return str.replace(/\W/gi, '').replace(/(.{2})/g, '$1 ').trim()
} 